import * as yup from 'yup';
import { l10n } from '@ott/l10n';
import { FORM_FIELDS } from '../constants';

export default () =>
  yup
    .object()
    .shape({
      [FORM_FIELDS.EMAIL]: yup
        .string()
        .email(l10n('emailSubscription.errors.email'))
        .required(l10n('emailSubscription.errors.required')),
    })
    .required();
